var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: "nav-slide" } }, [
    _vm.showBanner
      ? _c(
          "div",
          {
            staticClass:
              "banner-wrapper d-flex justify-content-center align-items-center"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "banner-content flex-row align-items-center justify-content-center d-none d-md-flex"
              },
              [
                _vm.bannerImage
                  ? _c("div", [
                      _c("img", {
                        staticStyle: { "max-height": "35px" },
                        attrs: { src: _vm.bannerImage }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-row align-items-center headline",
                    style: { color: _vm.headlineColor }
                  },
                  [
                    _vm.headlineIcon
                      ? _c("InlineSvg", { attrs: { src: _vm.headlineIcon } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.headline ? [_vm._v(_vm._s(_vm.headline))] : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.coundtdown
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex flex-row align-items-center",
                        style: { color: _vm.countdownColor }
                      },
                      [
                        _c("AppCountdown", {
                          staticClass: "countdown",
                          attrs: { countdownTime: _vm.coundtdown },
                          on: { "countdown-finished": _vm.countdownFinished }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButton && _vm.buttonStyle === "button"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row align-items-center button cursor-pointer",
                        style: {
                          backgroundColor: _vm.buttonBGColor,
                          color: _vm.buttonColor
                        },
                        on: { click: _vm.goToButtonLink }
                      },
                      [
                        _vm.buttonText
                          ? [_vm._v(_vm._s(_vm.buttonText))]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.buttonIcon
                          ? _c("InlineSvg", { attrs: { src: _vm.buttonIcon } })
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButton && _vm.buttonStyle === "line"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row align-items-center button line cursor-pointer",
                        style: { color: _vm.buttonColor },
                        on: { click: _vm.goToButtonLink }
                      },
                      [
                        _vm.buttonText
                          ? [_vm._v(_vm._s(_vm.buttonText))]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.buttonIcon
                          ? _c("InlineSvg", { attrs: { src: _vm.buttonIcon } })
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showClose
                  ? _c("InlineSvg", {
                      staticClass: "close-ico position-absolute cursor-pointer",
                      staticStyle: { right: "10px" },
                      attrs: { src: "/images/icons/ic-close.svg" },
                      on: { click: _vm.closeBanner }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "banner-content flex-row align-items-center justify-content-center d-flex d-md-none"
              },
              [
                _vm.bannerImageMobile
                  ? _c("div", [
                      _c("img", {
                        staticStyle: { "max-height": "35px" },
                        attrs: { src: _vm.bannerImageMobile }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-row align-items-center headline",
                    style: { color: _vm.headlineColor }
                  },
                  [
                    _vm.headlineIcon
                      ? _c("InlineSvg", { attrs: { src: _vm.headlineIcon } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.headlineMobileText
                      ? [_vm._v(_vm._s(_vm.headlineMobileText))]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.countdownShowMobile && _vm.coundtdown
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex flex-row align-items-center",
                        style: { color: _vm.countdownColor }
                      },
                      [
                        _c("AppCountdown", {
                          staticClass: "countdown",
                          attrs: { countdownTime: _vm.coundtdown },
                          on: { "countdown-finished": _vm.countdownFinished }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButton && _vm.buttonStyle === "button"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row align-items-center button cursor-pointer",
                        style: {
                          backgroundColor: _vm.buttonBGColor,
                          color: _vm.buttonColor
                        },
                        on: { click: _vm.goToButtonLink }
                      },
                      [
                        _vm.buttonMobileText
                          ? [_vm._v(_vm._s(_vm.buttonMobileText))]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.buttonIcon
                          ? _c("InlineSvg", { attrs: { src: _vm.buttonIcon } })
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showButton && _vm.buttonStyle === "line"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row align-items-center button line cursor-pointer",
                        style: { color: _vm.buttonColor },
                        on: { click: _vm.goToButtonLink }
                      },
                      [
                        _vm.buttonMobileText
                          ? [_vm._v(_vm._s(_vm.buttonMobileText))]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.buttonIcon
                          ? _c("InlineSvg", { attrs: { src: _vm.buttonIcon } })
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showClose
                  ? _c("InlineSvg", {
                      staticClass: "close-ico cursor-pointer",
                      attrs: { src: "/images/icons/ic-close.svg" },
                      on: { click: _vm.closeBanner }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }